import { Typography } from '@atlas-metrics/design-system';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
  Block,
  Document,
  Inline,
  INLINES,
  Text,
} from '@contentful/rich-text-types';
import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

import Icon from '@/components/ui/Icon';

export interface IProps {
  linkCaption?: string;
  linkURL?: string;
  className?: string;
  richText?: Document;
}

const Paragraph: React.FC<PropsWithChildren<IProps>> = ({
  className,
  linkCaption,
  linkURL,
  richText,
  children,
}) => {
  const Link = ({ node }: { node: Block | Inline }) => (
    <a
      href={node.data.uri}
      target='_blank'
      rel='noopener noreferrer'
      className='mt-3 flex cursor-pointer items-center gap-2 text-s font-medium text-ds-purple-600'
    >
      {(node.content[0] as Text).value}
      <Icon name='icon-external-link' className='h-3 w-3 text-ds-purple-600' />
    </a>
  );

  const options = {
    renderNode: {
      [INLINES.HYPERLINK]: (node: Block | Inline) => <Link node={node} />,
    },
  };

  return (
    <div className={clsxm('flex flex-col gap-3', className)}>
      {richText && (
        <span className='text-s font-medium tracking-wide text-ds-grey-600'>
          {documentToReactComponents(richText, options)}
        </span>
      )}
      <Typography variant='body-s' className='text-ds-grey-600'>
        {children}
      </Typography>
      {linkCaption && (
        <Typography variant='body-s' className='text-ds-purple-600'>
          <a href={linkURL} target='_blank' rel='noreferrer'>
            {linkCaption}
          </a>
        </Typography>
      )}
    </div>
  );
};

export default Paragraph;
